/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect } from "react";

import { Box, Grid, Card } from "@mui/material";
import { green } from "@mui/material/colors";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import CustomMaterialTable from "../../components/custom/CustomMaterialTable";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import MDTypography from "components/MDTypography";
import Loader from "components/custom/Loader";
import MDBox from "components/MDBox";
import Check from "@mui/icons-material/Check";
import ScheduleIcon from "@mui/icons-material/Schedule";
import DoneIcon from "@mui/icons-material/Done";
import dashboard2 from "../../assets/cms-icons/session.png";
import dashboard3 from "../../assets/cms-icons/dashboard3.png";
import avgSessionIcon from "../../assets/cms-icons/4wac.png"
import { useLocation } from "react-router-dom";
import { useMaterialUIController } from "context";
import { useNavigate } from "react-router-dom";
import useApiRequest from "utils/Apirequest";
import DashboardCard from "examples/Cards/InfoCards/DashboardCard";
import dummyImg from "../../assets/images/dummy_Image.png"


import {
  SESSION_STATUS_PRIORITY,
  sortByStatusPriority,
} from "utils/statusPriority";

import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";

import { Image, Tag } from "antd";
import { AutoTooltip } from "utils/Constant";
import { enqueueSnackbar, useSnackbar } from "notistack";
import MDButton from "components/MDButton";
import LaunchIcon from "@mui/icons-material/Launch";
import { getSecureUrl } from "utils/secureDownload";

import { useMemo } from "react";
import { convertUTCtoDubai } from "utils/Constant";
import GlobalDateFilter from "utils/GlobalDateFilter";

const QontoStepIconRoot = styled("div")(({ theme }) => ({
  color: "#eaeaf0",
  display: "flex",
  height: 22,
  alignItems: "center",
  "& .QontoStepIcon-completedIcon": {
    color: "#784af4",
    zIndex: 1,
    fontSize: 18,
  },
  "& .QontoStepIcon-circle": {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "currentColor",
  },
  ...theme.applyStyles("dark", {
    color: theme.palette.grey[700],
  }),
  variants: [
    {
      props: ({ ownerState }) => ownerState.active,
      style: {
        color: "#784af4",
      },
    },
  ],
}));

function QontoStepIcon(props) {
  const { active, completed, className } = props;

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <Check className="QontoStepIcon-completedIcon" />
      ) : (
        <div className="QontoStepIcon-circle" />
      )}
    </QontoStepIconRoot>
  );
}

QontoStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
};

const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  zIndex: 1,
  color: "#fff",
  width: 50,
  height: 50,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: ownerState.completed
    ? green[500]
    : ownerState.active
      ? "yellow"
      : "red",
}));

function ColorlibStepIcon(props) {
  const { active, completed, icon, className } = props;

  const icons = {
    1: <DoneIcon />,
    2: <DoneIcon />,
    3: <DoneIcon />,
    4: <ScheduleIcon />,
  };

  return (
    <ColorlibStepIconRoot
      ownerState={{ completed, active }}
      className={className}
    >
      {icons[String(icon)]}
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};

const statusList1 = ["Active", "Completed"];

const ViewDriver = () => {
  const location = useLocation();

  const [content, setContent] = useState(location?.state);
  const [columns, setColumns] = useState([]);
  const [rows1, setRows1] = useState([]);
  const [isLoading1, setIsLoading1] = useState(true);
  const [controller, dispatch] = useMaterialUIController();
  const { darkMode } = controller;
  const { sidenavColor } = controller;
  const [cardData, setCardData] = useState({});
  const navigate = useNavigate();
  const handleTransactionEdit = (row_data) => {
    if (window.innerWidth < 1200) {
      const { setMiniSidenav } = require("context");
      setMiniSidenav(dispatch, true);
    }
    navigate("/session", { state: { _id: row_data?.sessionId } });
  };
  const apiRequest = useApiRequest();

  const [vehicleImageUrl, setVehicleImageUrl] = useState("");
  const [vehicleImageLoading, setVehicleImageLoading] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [timeRange, setTimeRange] = useState("today");


  const fetchSession = async () => {
    const { data } =
      (await apiRequest(
        "get",
        `users/user/${content?.rfidTag}/history?filter=${timeRange}&startDate=${fromDate}&endDate=${toDate}`,
        null,
        {},
        {}
      )) || {};

    if (data?.status === true) {
      const normalizedSessions = (data.data || []).map((session) => ({
        ...session,
        status:
          session.status === "Started"
            ? "Active"
            : session.status === "Stopped"
              ? "Completed"
              : session.status === "Completed"
                ? "Completed"
                : session.status,
      }));

      const sortedSessions = sortByStatusPriority(
        normalizedSessions,
        SESSION_STATUS_PRIORITY,
        "createdAt" // secondary sort (latest first)
      );

      setRows1(sortedSessions);
      setCardData(data?.get_dash_data);
      setIsLoading1(false);
    }
    else {
      setIsLoading1(false);
      setRows1([]);
    }
  };


  const fetchSecureVehicleImage = async (imgPath) => {
    setVehicleImageLoading(true);

    const url = await getSecureUrl(imgPath);

    setVehicleImageUrl(url || "../../assets/images/dummy_Image.png");

    setVehicleImageLoading(false);
  };

  useEffect(() => {
    setContent(location?.state);
    fetchSession();
    setColumns(sessionColumn);
  }, [timeRange, fromDate, toDate]);

  useEffect(() => {
    const vehicleImgPath = `${content?.user_vehicle?.[0]?.vehicle_img}`;
    fetchSecureVehicleImage(vehicleImgPath);

    return () => {
      setVehicleImageUrl((prev) => {
        if (prev && prev.startsWith("blob:")) {
          try {
            URL.revokeObjectURL(prev);
          } catch (e) { }
        }
        return "";
      });
    };
  }, [content?.user_vehicle?.[0]?.vehicle_img]);



  const handleFilterChange = (filter) => {
    setIsLoading1(true);

    if (filter?.preset) {
      setTimeRange(filter?.preset);
      setFromDate(null);
      setToDate(null);
    }
    if (filter?.startDate && filter?.endDate) {
      setTimeRange("custom");
      setFromDate(filter.startDate);
      setToDate(filter.endDate);
    }
  };

  const handleViewSession = (row_data) => {
    try {
      navigate("/view-transaction", {
        state: {
          _id: row_data?._id,   // session ID
        },
      });
    } catch (error) {
      enqueueSnackbar("Failed to open session page", { variant: "error" });
    }
  };





  const sessionColumn = useMemo(
    () => [
      {
        header: "Status",
        accessorKey: "status",
        filterVariant: "select",
        filterSelectOptions: statusList1,
        align: "center",
        fixed: "true",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
        Cell: (row) => (
          <MDBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            borderRadius="md"
            bgcolor="rgba(25, 128, 56, 0.2)"
            style={{
              flex: 1,
            }}
          >
            <Tag
              color={
                row.row.original.status === "Completed"
                  ? "green"
                  : row.row.original.status === "Stopped"
                    ? "red"
                    : row.row.original.status === "Started"
                      ? "blue"
                      : "yellow"
              }
            >
              {row.row.original.status}
            </Tag>
          </MDBox>
        ),
      },
      {
        header: "Session ID",
        accessorKey: "sessionId",
        size: 210,
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
        Cell: ({ cell }) => {
          const sessionId = cell.getValue() || "";
          const navigate = useNavigate();


          return (
            <AutoTooltip maxWidth={250}>
              <span
                style={{
                  color: "#1976d2",
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
                onClick={() =>
                  navigate("/session", {
                    state: { _id: sessionId, chargerName: cell?.row?.original?.chargerName },
                  })
                }
              >
                {sessionId}
              </span>
            </AutoTooltip>
          );
        },
      },
      {
        header: "Charger ID",
        size: 220,
        accessorKey: "chargerId",
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },
      {
        header: "Charger Name",
        size: 250,
        accessorKey: "chargerName",
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },
      {
        header: "Duration",
        size: 210,
        accessorKey: "chargeTime",
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return value === "NaN:NaN:NaN" || !value ? "-" : value;
        }

      },
      {
        header: "Location",
        size: 220,
        accessorKey: "locationName",
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
        Cell: ({ cell }) => {
          const location = cell.getValue() || ' ';
          return <AutoTooltip maxWidth={150}>{location}</AutoTooltip>;
        },
      },
      {
        header: "Started At",
        size: 220,
        accessorKey: "createdAt",
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
        Cell: ({ cell }) => {
          return convertUTCtoDubai(cell.getValue());
        },
      },
      {
        header: "End At",
        size: 200,
        accessorKey: "endTime",
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
        Cell: ({ cell }) => {
          return convertUTCtoDubai(cell.getValue());
        },
      },

      {
        header: "Energy disperse",
        size: 260,
        accessorKey: "EnergyConsumed",
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
        Cell: ({ cell }) => {
          const raw = cell.getValue();

          const wh = parseFloat(raw.replace(/Wh/i, "").trim());

          const kwh = (wh / 1000).toFixed(2);

          return `${kwh} kWh`;
        },
      },
      {
        header: "Revenue",
        size: 190,
        accessorKey: "revenue",
        align: "center",
        muiTableHeadCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },

        Cell: ({ row }) => {
          const energyRaw = row.original.EnergyConsumed;
          const cost = row.original.costPerUnit?.amount || 0;
          const currency = row.original.costPerUnit?.currency || "";
          const wh = parseFloat(energyRaw.replace(/Wh/i, "").trim());
          const kwh = wh / 1000;
          const rate = cost * 1000;
          const revenue = (kwh * rate).toFixed(2);
          return `${currency} ${revenue}`;
        },
      },
      {
        header: "Action",
        accessorKey: "actions",
        enableColumnFilter: false,
        align: "center",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
        size: 180,
        Cell: (row) => (
          <div
            style={{
              position: "sticky",
              right: "0",

              zIndex: "111",
            }}
          >
            <MDButton
              onClick={(e) => handleTransactionEdit(row.row.original)}
              variant="gradient"
              color={sidenavColor}
              iconOnly
            >
              <LaunchIcon />
            </MDButton>
          </div>
        ),
      },
    ],

    [sidenavColor]
  );
  useEffect(() => {
    setColumns(sessionColumn);
  }, [sidenavColor]);



  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Box>
          {/* First Row - Driver Info, Vehicle Image, Vehicle Info */}
          <Grid container spacing={3} mb={3}>
            {/* Driver Info Card */}
            <Grid item xs={12} md={4}>
              <Card
                sx={{
                  boxShadow: darkMode
                    ? "0 4px 12px rgba(0,0,0,0.3)"
                    : "0 4px 12px rgba(0,0,0,0.1)",
                  borderRadius: "16px",
                  border: "1px solid",
                  borderColor: darkMode
                    ? "rgba(255,255,255,0.1)"
                    : "rgba(0,0,0,0.08)",
                  height: "100%",
                }}
              >
                <MDBox p={3}>
                  {/* Status Tag */}
                  <MDBox mb={1.5}>
                    {content?.status === "active" ? (
                      <Tag
                        icon={<CheckCircleOutlined />}
                        color="success"
                        style={{
                          fontSize: "0.875rem",
                          fontWeight: "bold",
                          padding: "6px 16px",
                          borderRadius: "12px",
                        }}
                      >
                        Active
                      </Tag>
                    ) : content?.status === "inactive" ? (
                      <Tag
                        icon={<CloseCircleOutlined />}
                        color="error"
                        style={{
                          fontSize: "0.875rem",
                          fontWeight: "bold",
                          padding: "6px 16px",
                          borderRadius: "12px",
                        }}
                      >
                        Inactive
                      </Tag>
                    ) : (
                      <Tag
                        icon={<ClockCircleOutlined />}
                        color="default"
                        style={{
                          fontSize: "0.875rem",
                          fontWeight: "bold",
                          padding: "6px 16px",
                          borderRadius: "12px",
                        }}
                      >
                        {content?.status}
                      </Tag>
                    )}
                  </MDBox>

                  {/* Driver Name */}
                  <MDTypography variant="h4" fontWeight="bold" mb={2}>
                    {content?.firstName} {content?.lastName}
                  </MDTypography>

                  {/* Driver Details */}
                  <Grid container spacing={1.5}>
                    <Grid item xs={12}>
                      <MDBox>
                        <MDTypography
                          variant="caption"
                          sx={{
                            opacity: 0.7,
                            textTransform: "uppercase",
                            fontSize: "0.65rem",
                            letterSpacing: "0.5px",
                          }}
                        >
                          Email Address
                        </MDTypography>
                        <MDTypography
                          variant="body2"
                          fontWeight="medium"
                          mt={0.3}
                        >
                          {content?.email ? content.email : "N/A"}
                        </MDTypography>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12}>
                      <MDBox>
                        <MDTypography
                          variant="caption"
                          sx={{
                            opacity: 0.7,
                            textTransform: "uppercase",
                            fontSize: "0.65rem",
                            letterSpacing: "0.5px",
                          }}
                        >
                          Driver ID
                        </MDTypography>
                        <MDTypography
                          variant="body2"
                          fontWeight="medium"
                          mt={0.3}
                        >
                          {content?.rfidTag || "N/A"}

                        </MDTypography>
                      </MDBox>
                    </Grid>
                    <Grid item xs={6}>
                      <MDBox>
                        <MDTypography
                          variant="caption"
                          sx={{
                            opacity: 0.7,
                            textTransform: "uppercase",
                            fontSize: "0.65rem",
                            letterSpacing: "0.5px",
                          }}
                        >
                          Gender
                        </MDTypography>
                        <MDTypography
                          variant="body2"
                          fontWeight="medium"
                          mt={0.3}
                        >
                          {content?.gender}
                        </MDTypography>
                      </MDBox>
                    </Grid>
                    <Grid item xs={6}>
                      <MDBox>
                        <MDTypography
                          variant="caption"
                          sx={{
                            opacity: 0.7,
                            textTransform: "uppercase",
                            fontSize: "0.65rem",
                            letterSpacing: "0.5px",
                          }}
                        >
                          Date of Birth
                        </MDTypography>
                        <MDTypography
                          variant="body2"
                          fontWeight="medium"
                          mt={0.3}
                        >
                          {content?.dob ? content.dob : "N/A"}
                        </MDTypography>
                      </MDBox>
                    </Grid>
                  </Grid>
                </MDBox>
              </Card>
            </Grid>

            {/* Vehicle Image Card */}
            <Grid item xs={12} md={4}>
              <Card
                sx={{
                  boxShadow: darkMode
                    ? "0 4px 12px rgba(0,0,0,0.3)"
                    : "0 4px 12px rgba(0,0,0,0.1)",
                  borderRadius: "16px",
                  border: "1px solid",
                  borderColor: darkMode
                    ? "rgba(255,255,255,0.1)"
                    : "rgba(0,0,0,0.08)",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <MDBox
                  p={3}
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  height="100%"
                >
                  {/* Vehicle Image Header */}
                  <MDTypography
                    variant="h5"
                    fontWeight="bold"
                    mb={2}
                    textAlign="center"
                  >
                    Vehicle
                  </MDTypography>

                  {/* Vehicle Image */}
                  <MDBox
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      p: 2,
                      backgroundColor: darkMode
                        ? "rgba(255,255,255,0.03)"
                        : "rgba(0,0,0,0.02)",
                      borderRadius: "12px",
                      minHeight: "180px",
                      flex: 1,
                    }}
                  >
                    {vehicleImageLoading ? (
                      <div style={{ padding: 20 }}>Loading image…</div>
                    ) : (
                      // eslint-disable-next-line jsx-a11y/img-redundant-alt
                      <Image
                      src={vehicleImageUrl}
                      alt="Vehicle Image"
                      preview={false}
                      fallback={dummyImg}     
                      style={{
                        maxWidth: "100%",
                        maxHeight: "150px",
                        objectFit: "contain",
                      }}
                    />
                    )}
                  </MDBox>

                  {/* Vehicle Name */}
                  <MDTypography
                    variant="h6"
                    fontWeight="bold"
                    textAlign="center"
                    mt={2}
                  >
                    {content?.user_vehicle[0]?.make}{" "}
                    {content?.user_vehicle[0]?.model}
                  </MDTypography>
                  <MDTypography
                    variant="caption"
                    textAlign="center"
                    sx={{ opacity: 0.7 }}
                  >
                    {content?.user_vehicle[0]?.variant}
                  </MDTypography>
                </MDBox>
              </Card>
            </Grid>

            {/* Vehicle Info Card */}
            <Grid item xs={12} md={4}>
              <Card
                sx={{
                  boxShadow: darkMode
                    ? "0 4px 12px rgba(0,0,0,0.3)"
                    : "0 4px 12px rgba(0,0,0,0.1)",
                  borderRadius: "16px",
                  border: "1px solid",
                  borderColor: darkMode
                    ? "rgba(255,255,255,0.1)"
                    : "rgba(0,0,0,0.08)",
                  height: "100%",
                }}
              >
                <MDBox p={3}>
                  {/* Vehicle Info Header */}
                  <MDTypography variant="h5" fontWeight="bold" mb={2}>
                    Vehicle Information
                  </MDTypography>

                  {/* Vehicle Details */}
                  <Grid container spacing={1.5} mb={2}>
                    <Grid item xs={6}>
                      <MDBox>
                        <MDTypography
                          variant="caption"
                          sx={{
                            opacity: 0.7,
                            textTransform: "uppercase",
                            fontSize: "0.6rem",
                            letterSpacing: "0.5px",
                          }}
                        >
                          Type
                        </MDTypography>
                        <MDTypography
                          variant="body2"
                          fontWeight="bold"
                          mt={0.3}
                          sx={{ fontSize: "0.8rem" }}
                        >
                          {content?.user_vehicle[0]?.type || "N/A"}
                        </MDTypography>
                      </MDBox>
                    </Grid>
                    <Grid item xs={6}>
                      <MDBox>
                        <MDTypography
                          variant="caption"
                          sx={{
                            opacity: 0.7,
                            textTransform: "uppercase",
                            fontSize: "0.6rem",
                            letterSpacing: "0.5px",
                          }}
                        >
                          Make
                        </MDTypography>
                        <MDTypography
                          variant="body2"
                          fontWeight="bold"
                          mt={0.3}
                          sx={{ fontSize: "0.8rem" }}
                        >
                          {content?.user_vehicle[0]?.make || "N/A"}
                        </MDTypography>
                      </MDBox>
                    </Grid>
                    <Grid item xs={6}>
                      <MDBox>
                        <MDTypography
                          variant="caption"
                          sx={{
                            opacity: 0.7,
                            textTransform: "uppercase",
                            fontSize: "0.6rem",
                            letterSpacing: "0.5px",
                          }}
                        >
                          Model
                        </MDTypography>
                        <MDTypography
                          variant="body2"
                          fontWeight="bold"
                          mt={0.3}
                          sx={{ fontSize: "0.8rem" }}
                        >
                          {content?.user_vehicle[0]?.model || "N/A"}
                        </MDTypography>
                      </MDBox>
                    </Grid>
                    <Grid item xs={6}>
                      <MDBox>
                        <MDTypography
                          variant="caption"
                          sx={{
                            opacity: 0.7,
                            textTransform: "uppercase",
                            fontSize: "0.6rem",
                            letterSpacing: "0.5px",
                          }}
                        >
                          Variant
                        </MDTypography>
                        <MDTypography
                          variant="body2"
                          fontWeight="bold"
                          mt={0.3}
                          sx={{ fontSize: "0.8rem" }}
                        >
                          {content?.user_vehicle[0]?.variant || "N/A"}
                        </MDTypography>
                      </MDBox>
                    </Grid>
                    <Grid item xs={6}>
                      <MDBox>
                        <MDTypography
                          variant="caption"
                          sx={{
                            opacity: 0.7,
                            textTransform: "uppercase",
                            fontSize: "0.6rem",
                            letterSpacing: "0.5px",
                          }}
                        >
                          VIN
                        </MDTypography>
                        <MDTypography
                          variant="body2"
                          fontWeight="bold"
                          mt={0.3}
                          sx={{ fontSize: "0.8rem" }}
                        >
                          {content?.user_vehicle[0]?.vin || "N/A"}
                        </MDTypography>
                      </MDBox>
                    </Grid>
                    <Grid item xs={6}>
                      <MDBox>
                        <MDTypography
                          variant="caption"
                          sx={{
                            opacity: 0.7,
                            textTransform: "uppercase",
                            fontSize: "0.6rem",
                            letterSpacing: "0.5px",
                          }}
                        >
                          VID
                        </MDTypography>
                        <MDTypography
                          variant="body2"
                          fontWeight="bold"
                          mt={0.3}
                          sx={{ fontSize: "0.8rem" }}
                        >
                          {content?.user_vehicle[0]?.vid || "N/A"}
                        </MDTypography>
                      </MDBox>
                    </Grid>
                  </Grid>

                  {/* Registration & Range */}
                  <Grid container spacing={1.5}>
                    <Grid item xs={12}>
                      <MDBox
                        sx={{
                          background:
                            "linear-gradient(195deg, #ef0000, #ef0000)",
                          borderRadius: "10px",
                          padding: "12px",
                          boxShadow: "0 4px 12px rgba(239, 0, 0, 0.3)",
                        }}
                      >
                        <MDTypography
                          variant="caption"
                          sx={{
                            color: "rgba(255,255,255,0.8)",
                            textTransform: "uppercase",
                            fontSize: "0.6rem",
                            letterSpacing: "0.5px",
                          }}
                        >
                          Registration Number
                        </MDTypography>
                        <MDTypography
                          variant="h6"
                          fontWeight="bold"
                          sx={{ color: "#ffffff", mt: 0.3 }}
                        >
                          {content?.user_vehicle[0]?.vehicle_reg || "N/A"}
                        </MDTypography>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12}>
                      <MDBox
                        sx={{
                          background: darkMode
                            ? "linear-gradient(135deg, rgba(32, 41, 64, 0.95) 0%, rgba(32, 41, 64, 1) 100%)"
                            : "linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%)",
                          borderRadius: "10px",
                          padding: "12px",
                          border: "2px solid",
                          borderColor: darkMode
                            ? "rgba(255,255,255,0.1)"
                            : "rgba(0,0,0,0.08)",
                        }}
                      >
                        <MDTypography
                          variant="caption"
                          sx={{
                            opacity: 0.7,
                            textTransform: "uppercase",
                            fontSize: "0.6rem",
                            letterSpacing: "0.5px",
                          }}
                        >
                          Range
                        </MDTypography>
                        <MDTypography
                          variant="h6"
                          fontWeight="bold"
                          sx={{ mt: 0.3 }}
                        >
                          {content?.user_vehicle[0]?.range || "N/A"}
                        </MDTypography>
                      </MDBox>
                    </Grid>
                  </Grid>
                </MDBox>
              </Card>
            </Grid>
          </Grid>

          <Grid container spacing={3} mb={3}>
            <Grid item xs={12} sm={6} md={4}>
              <DashboardCard
                color="success"
                colorcode="#9F9F9F"
                selectedCardCode="#EEFFE3"
                imgicon={dashboard3}
                title="Energy Consumed"
                driverFontSize="1.7rem"
                titleFontSize="1.20rem"
                driverCount={
                  (
                    parseFloat(
                      String(cardData?.total_energy_consumed || "0").replace(/wh/i, "").trim()
                    )
                  ).toFixed(2) + " kWh"
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <DashboardCard
                color="info"
                colorcode="#C5C0FF"
                selectedCardCode="#F1F0FF"
                imgicon={dashboard2}
                title="Charging Session"
                driverFontSize="1.7rem"
                titleFontSize="1.20rem"
                driverCount={cardData?.total_sessions || 0}
                percentage={{
                  color: "success",
                  amount: "+1%",
                  label: "than yesterday",
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <DashboardCard imgicon={dashboard2}
                color="purple"
                colorcode="#C5C0FF"
                selectedCardCode="#F1F0FF"
                title="Avg. Session Duration"
                driverCount={cardData?.average_session_duration || 0}
                driverFontSize="1.7rem"
                titleFontSize="1.20rem"
                percentage={{
                  color: "success",
                  amount: "+1%",
                  label: "than yesterday",
                }}
              />
            </Grid>
          </Grid>

          {/* Sessions Table */}
          <MDBox mt={8}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={1}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow="info"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <MDTypography variant="h6" color="white">
                  All Sessions of {content?.firstName} {content?.lastName}
                </MDTypography>


              </MDBox>

              <MDBox mt={3} px={{ xs: 1, sm: 2 }}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <GlobalDateFilter
                      onChange={handleFilterChange}
                    />
                    {isLoading1 ? (
                      <Loader />
                    ) : (
                      <Box mt={2}>
                        <CustomMaterialTable
                          columns={columns}
                          data={rows1}
                          darkMode={darkMode}
                        />
                      </Box>
                    )}
                  </Grid>
                </Grid>
              </MDBox>
            </Card>
          </MDBox>
        </Box>
      </MDBox>
    </DashboardLayout>
  );
};

export default ViewDriver;